export const WHATSAPP_CONTACT_URL =
  'https://api.whatsapp.com/send/?phone=551148631430&type=phone_number&app_absent=0';

// `titleKey` feeds the browser tab (routes/dashboard/locked). It points at the
// nav label, not the page headline: the headline is marketing copy and reads as
// nonsense truncated into a tab.
export const LOCKED_FEATURES = {
  campaigns: { icon: 'megaphone-2', titleKey: 'SIDEBAR.CAMPAIGNS' },
  help_center: { icon: 'library', titleKey: 'SIDEBAR.HELP_CENTER.TITLE' },
  inbox: { icon: 'mail-inbox-all', titleKey: 'SIDEBAR.INBOXES' },
  reports: {
    icon: 'graph-increase',
    titleKey: 'SIDEBAR.REPORTS_ADVANCED_LOCKED',
  },
};

export const LOCKED_FEATURE_KEYS = Object.keys(LOCKED_FEATURES);

export const lockedFeatureURL = (accountId, feature) =>
  `accounts/${accountId}/locked/${feature}`;

// One route name per feature: the sidebar resolves the active secondary menu by
// route name (Sidebar.vue#activeSecondaryMenu, first match wins), so a single
// shared name would make every upsell page inherit the same section.
export const lockedFeatureRouteName = feature => `locked_${feature}`;

const CLAUDIA_ONLY_LOCKED_PATHS = [
  { pattern: /\/accounts\/\d+\/campaigns(\/|$)/, feature: 'campaigns' },
  { pattern: /\/accounts\/\d+\/portals(\/|$)/, feature: 'help_center' },
  { pattern: /\/accounts\/\d+\/settings\/inboxes(\/|$)/, feature: 'inbox' },
  { pattern: /\/accounts\/\d+\/reports(\/|$)/, feature: 'reports' },
];

export const lockedFeatureForPath = path => {
  const match = CLAUDIA_ONLY_LOCKED_PATHS.find(({ pattern }) =>
    pattern.test(path)
  );
  return match ? match.feature : null;
};
